export type SuggestionLabel = 'Specialties' | 'Practices' | 'Practitioners' | 'Topics';

export enum SearchSuggestionCategory {
  SPECIALTY = 'service',
  PRACTICE = 'practice',
  PRACTITIONER = 'practitioner',
  TOPIC = 'specialisation & procedure',
}

export enum PluraliseSearchSuggestionCategory {
  SPECIALTY = 'Services',
  PRACTICE = 'Practices',
  PRACTITIONER = 'Practitioners',
  TOPIC = 'Specialisations & Procedures',
}

export const DEFAULT_SPECIALTY_ICONS: Record<string, string | undefined> = {
  gp: '/public/images/gp_20190307073159.png',
  telehealth: '/public/images/mp_telehealth_20210316070622.png',
  'covid-19 vaccinations': '/public/images/covid19vaccinations_marketplace_20210316072639.png',
  physiotherapist: '/public/images/physio_20190307073330.png',
  dentist: '/public/images/dentist_20190307073112.png',
  'flu vaccinations': '/public/images/fluvax-drop-shadow_20210618021506.png',
  chiropractor: '/public/images/chiro_20190307072939.png',
  optometrist: '/public/images/optometrist_20190307073249.png',
  podiatrist: '/public/images/podiatrist_20190307073411.png',
  psychologist: '/public/images/psychologist_20190307073453.png',
  audiologist: '/public/images/audiologist_20190307072843.png',
  counselling: '/public/images/councellor_20190307073032.png',
  'skin cancer physician': '/public/images/skin_checks_20190307073603.png',
  'covid-19 testing': '/public/images/covid-19-testing_20210826010743.png',
  radiologist: '/public/images/Radiology%20icon_20220310011241.png',
};
